<template>
  <div id="app">
    <!-- Header -->
    <header v-if="$route.name === 'Index'">
      <the-header></the-header>
    </header>
    <!-- Main Content -->
    <vue-page-transition name="overlay-right-full">
      <router-view :musicFromHomeProp='musicFromHome'></router-view>
    </vue-page-transition>
    <!-- Custom Mouse Cursor -->
    <v-cursor></v-cursor>
  </div>
</template>

<script>
import VCursor from '@/components/VCursor.vue'
import TheHeader from '@/components/TheHeader.vue'

export default {
  name: 'App',
  components: {
    'v-cursor': VCursor,
    'the-header': TheHeader
  },
  data () {
    return {
      musicFromHome: false
    }
  },
  watch: {
    $route (to, from) {
      if (from.name === 'Index') {
        this.$root.$on('playMusic', isPlayerOn => {
          // TODO:
          // DISABLED FOR NOW
          // this.musicFromHome = true
          // this.generateCrossAudioPath.pause()
          // console.log('daaaa')
          // this.isMusicOn = false
          // console.log(this.isMusicOn);
          // this.generateAudioPath.volume = 1
          // this.generateAudioPath.play(this.currentPlayerTime)
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import '@/assets/scss/main.scss';
</style>
